// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__1ibXL","popup":"style_popup__1nclg"};